/** @fileoverview Toasts of an app screen: their own stack at the top centre, under the app bar. */

import { CircleCheck, TriangleAlert } from 'lucide-react';

import {
  createToastManager,
  Toast,
  ToastClose,
  ToastContent,
  ToastDescription,
  ToastPortal,
  ToastProvider,
  ToastTitle,
  ToastViewport,
  useToastManager,
} from '../ui/toast';

/** The toast manager of app screens, apart from the builder chat's toasts at the top left. */
export const appToast = createToastManager();

/** Lists the open app toasts, each with its icon, title, description and close button. */
const AppToastList = () => {
  const { toasts } = useToastManager();
  return toasts.map((toastItem) => (
    <Toast key={toastItem.id} toast={toastItem}>
      <ToastContent>
        <div className="flex min-w-0 items-center gap-2">
          {toastItem.type === 'warning' ? (
            <TriangleAlert className="size-4 shrink-0 text-muted-foreground" aria-hidden="true" />
          ) : (
            <CircleCheck className="size-4 shrink-0 text-primary" aria-hidden="true" />
          )}
          <ToastTitle className="min-w-0 flex-1 type-body" />
          <ToastClose />
        </div>
        <ToastDescription className="ml-6 line-clamp-3 type-small" />
      </ToastContent>
    </Toast>
  ));
};

/** Shows app toasts at the top centre of the page, below the app bar, so they sit near the work. */
export default function AppToaster() {
  return (
    <ToastProvider toastManager={appToast}>
      <ToastPortal>
        <ToastViewport className="inset-x-0 top-20 mx-auto">
          <AppToastList />
        </ToastViewport>
      </ToastPortal>
    </ToastProvider>
  );
}
